import { render, staticRenderFns } from "./MrfEventsCreate.vue?vue&type=template&id=0171f1da"
import script from "./MrfEventsCreate.vue?vue&type=script&lang=js"
export * from "./MrfEventsCreate.vue?vue&type=script&lang=js"
import style0 from "./MrfEventsCreate.vue?vue&type=style&index=0&id=0171f1da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports